import { Link } from "react-router-dom";
import { ArrowRight, ScanLine, Sparkles } from "lucide-react";
import { IMAGES } from "@/lib/api";

export default function Hero() {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-24 lg:pt-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <p className="fade-up inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-brand-accent">
            <Sparkles className="w-3.5 h-3.5" /> AI-powered interior estimates
          </p>
          <h1 className="fade-up delay-1 font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] text-brand-ink mt-6">
            Your floor plan,<br /><em className="text-brand-accent">priced</em> in seconds.
          </h1>
          <p className="fade-up delay-2 mt-7 text-base md:text-lg text-brand-muted max-w-lg leading-relaxed">
            Upload your floor plan and our AI reads every room, measures every corner and crafts a detailed,
            itemised quotation — ready to download as a PDF.
          </p>
          <div className="fade-up delay-3 mt-10 flex flex-wrap gap-4">
            <Link to="/estimate" className="group inline-flex items-center gap-3 rounded-full bg-brand-ink text-brand-cream px-7 py-4 text-sm hover:bg-brand-accent transition-colors duration-300" data-testid="hero-upload-btn">
              <ScanLine className="w-4 h-4" /> Upload Floor Plan
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/estimate?mode=manual" className="inline-flex items-center rounded-full border border-brand-ink/20 px-7 py-4 text-sm text-brand-ink hover:border-brand-accent hover:text-brand-accent transition-colors" data-testid="hero-manual-btn">
              Enter rooms manually
            </Link>
          </div>
          <div className="mt-14 flex gap-10 text-sm">
            {[["1,200+", "Homes delivered"], ["45 days", "Avg. handover"], ["10 yr", "Warranty"]].map(([n, l]) => (
              <div key={l}>
                <p className="font-serif-display text-3xl text-brand-ink">{n}</p>
                <p className="text-brand-muted-light mt-1">{l}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-6 relative">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-[0_40px_80px_-30px_rgba(43,36,32,0.45)]">
            <img src={IMAGES.hero} alt="Warm minimal living room by homiin" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -left-6 lg:-left-12 bottom-10 w-56 rounded-2xl bg-white/80 backdrop-blur-xl border border-white p-4 shadow-xl">
            <div className="relative rounded-xl overflow-hidden h-28 bg-brand-sand">
              <img src={IMAGES.plan2} alt="Floor plan being scanned" className="w-full h-full object-cover opacity-80" />
              <div className="scanline" />
            </div>
            <p className="text-xs text-brand-muted mt-3">AI detected</p>
            <p className="font-serif-display text-xl text-brand-ink">8 rooms · 1,140 sq.ft</p>
          </div>
        </div>
      </div>
    </section>
  );
}
